import { useState } from 'react';
import { ListItemText, Stack, ListItemSecondaryAction, ListItem } from '@mui/material';
import BaseFieldEditor from './BaseFieldEditor';
import ConfidenceIndicator from '../ConfidenceIndicator';
import PointTypeSelector from '../selectors/PointTypeSelector';

// eslint-disable-next-line
const PointTypeEditor = ({
  open,
  column,
  actions,
  editing,
  currentlyEditing,
  setCurrentlyEditing,
  setCurrentEditor,
}) => {
  if (!editing || editing.length <= 0) return null;
  const [selectedOption, setSelectedOption] = useState(editing[0].point_type_id);

  return (
    <BaseFieldEditor
      open={open}
      onSave={() => {
        // This is a bit excessive for now until we wrangle staging transformations
        const action = actions.find((a) => a.id === column.action);
        action.doSave(editing, {
          'p.point_type_id': selectedOption.id,
          'p.point_type': selectedOption.name,
          'p.point_type_id.cnf': 100,
          'p.point_type.cnf': 100,
        });
        action.doClose({ currentlyEditing, setCurrentlyEditing, column, setCurrentEditor });
      }}
      title="Point Type Editor"
      editing={editing}
      column={column}
      currentlyEditing={currentlyEditing}
      setCurrentlyEditing={setCurrentlyEditing}
      setCurrentEditor={setCurrentEditor}
      actions={actions}
    >
      <PointTypeSelector
        value={selectedOption}
        setValue={setSelectedOption}
        sortOptions={(a, b) => {
          if (editing.length !== 1) return 0;
          const aConfidence = editing[0].data?.['auto_tagger.point_type_preds']?.[a.name] || 0;
          const bConfidence = editing[0].data?.['auto_tagger.point_type_preds']?.[b.name] || 0;
          if (aConfidence && !bConfidence) {
            return -1; // 'a' will be shown before 'b'
          }
          if (!aConfidence && bConfidence) {
            return 1; // 'b' will be shown before 'a'
          }
          return 0; // no sorting applied
        }}
        renderOption={(props, option) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <ListItem {...props}>
            <ListItemText>{option.name}</ListItemText>
            <ListItemSecondaryAction>
              <Stack direction="row" spacing={4}>
                {editing.length === 1 &&
                  editing[0].data?.['auto_tagger.point_type_preds']?.[option.name] && (
                    <ConfidenceIndicator
                      value={editing[0].data['auto_tagger.point_type_preds'][option.name] * 100}
                    />
                  )}
              </Stack>
            </ListItemSecondaryAction>
          </ListItem>
        )}
      />
    </BaseFieldEditor>
  );
};

export default PointTypeEditor;
